"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { aboutPx as data } from "@/lib/data/press";

const accent = "var(--color-crimson)";

export function AboutPx() {
  return (
    <Section id="about-px" className="relative">
      <Container>
        <Reveal>
          <div className="text-center max-w-3xl mx-auto mb-10">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <div className="glass rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[rgb(var(--border)/0.18)] bg-[rgb(var(--border)/0.04)]">
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Metric</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Value</th>
                  </tr>
                </thead>
                <tbody>
                  {data.metrics.map((m) => (
                    <tr key={m.metric} className="border-b border-[rgb(var(--border)/0.08)]">
                      <td className="px-4 py-3 align-top">{m.metric}</td>
                      <td className="px-4 py-3 align-top text-right font-bold" style={{ color: accent }}>{m.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
        <Reveal delay={200}>
          <div className="mt-8 grid lg:grid-cols-3 gap-5">
            <div className="lg:col-span-2 glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>What We Do</span>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.whatWeDo}</p>
              <span className="eyebrow-tiny font-bold mt-4 block" style={{ color: accent }}>Who We Serve</span>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.whoWeServe}</p>
            </div>
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Our Commitment</span>
              <ul className="mt-3 space-y-1.5">
                {data.commitments.map((c, i) => (
                  <li key={i} className="text-sm text-[rgb(var(--fg-muted))]">{c}</li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
